import React, { useEffect, useRef, useState } from 'react';
import { Capacitor } from '@capacitor/core';

import { ReactComponent as Refresh } from 'assert/images/Common/refresh.svg';
import { PullToRefreshStyle } from './Component.style';

const THRESHOLD = 80;

const NativePullToRefresh = ({ onRefresh, enabled, children }) => {
  const touchStartY = useRef(null);
  const pulling = useRef(false);
  const [offsetY, setOffsetY] = useState(0);
  const [triggered, setTriggered] = useState(false);
  const [finalOffsetY, setFinalOffsetY] = useState(null);

  useEffect(() => {
    if (!Capacitor.isNativePlatform() || !enabled) return;

    const handleTouchStart = (e) => {
      if (window.scrollY === 0 && !triggered) {
        touchStartY.current = e.touches[0].clientY;
        pulling.current = true;
      }
    };

    const handleTouchMove = (e) => {
      if (!pulling.current || touchStartY.current === null || triggered) return;

      const currentY = e.touches[0].clientY;
      const diff = currentY - touchStartY.current;

      if (diff > 0) {
        e.preventDefault();
        setOffsetY(diff > 100 ? 100 : diff);
      } else {
        setOffsetY(0);
      }
    };

    const handleTouchEnd = () => {
      if (!pulling.current) return;
      pulling.current = false;

      if (offsetY >= THRESHOLD) {
        setTriggered(true);
        setFinalOffsetY(offsetY);
        onRefresh?.();

        setTimeout(() => {
          setTriggered(false);
          setOffsetY(0);
          setFinalOffsetY(null);
        }, 1000);
      } else {
        setOffsetY(0);
      }
      touchStartY.current = null;
    };

    window.addEventListener('touchstart', handleTouchStart, { passive: false });
    window.addEventListener('touchmove', handleTouchMove, { passive: false });
    window.addEventListener('touchend', handleTouchEnd);

    return () => {
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('touchmove', handleTouchMove);
      window.removeEventListener('touchend', handleTouchEnd);
    };
  }, [offsetY, triggered, enabled, onRefresh]);

  return (
    <>
      <PullToRefreshStyle
      // env(safe-area-inset-top, 0px) - 
        style={{
          top: `calc(50px + ${
            finalOffsetY !== null ? finalOffsetY : offsetY
          }px)`,
          display: offsetY > 0 || triggered ? 'flex' : 'none',
        }}
      >
        <Refresh
          className='refresh-icon'
          style={{
            width: 30,
            height: 30,
            animation: triggered ? 'spin 0.8s linear infinite' : undefined,
          }}
        />
      </PullToRefreshStyle>
      <div>{children}</div>
    </>
  );
};

export default NativePullToRefresh;
